export class Constanciadigital {
    id: number;
    acreditacionId: number;
    estatus: number;
    fechaImpresion: string;
    numeroConstancia: number;
    constanciHashCode: number;
    profecionistaID: number;
    fechaDescarga: string;
    usuario: string;
}
